<template>
  <v-card
    dark
    height="250"
    class="expande-horizontal pa-3 card-balance-style"
    style="flex-wrap: wrap; border-radius: 12px;"
  >
    <div class="expande-horizontal column" style="flex-wrap: nowrap;">
      <span style="font-size: 8pt;" class="fonte mb-2 white--text"
        >Total Investido</span
      >
      <div class="expande-horizontal">
        <span class="fonte-bold white--text" :style="`font-size: 26px;`"
          >{{ $helper.formataSaldo(totalPurchase) }}  
          <!-- de  -->
          <!-- {{ $helper.formataSaldo((getLoggedUser.career_info.price || 0) * 20) }} -->
        </span>
        <v-spacer></v-spacer>
        <v-btn @click="$router.push('/transactions')" icon color="grey">
          <v-icon size="30" color="white"> mdi-chevron-right </v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
    </div>

    <div class="expande-horizontal column">
      <span class="fonteMini">Próximos pagamentos</span>
      <v-btn :key="`i-i-${i}`" v-for="(proximoPagamento, i) in proximosPagamentos" depressed rounded outlined small light color="#555" class="mt-1">
        <span class="text-capitalize grey--text"> 
          {{ proximoPagamento.item.title }}: <span class="white--text font-weight-bold">{{ proximoPagamento.tempo_ate_la }}</span> dias para o seu resgate 
        </span>
      </v-btn>
    </div>

    <div class="expande-horizontal mt-3">

      <!-- <v-btn class="mr-2" @click="openPurchase({ ...getInvestments[0], purchase_type: 'investment' })" color="yellow" small> -->
      <v-btn class="mr-2" to="/investments" color="orange" block large>
        <span style="font-size: 16pt;" class="font-weight-bold black--text">Novo aporte </span>
      </v-btn>
      <!-- <v-btn @click="$router.push('/saque/purchase')" color="yellow" small>
        <span class="fonte-bold black--text">Retirada</span>
        <span style="font-size: 20pt;"></span>
      </v-btn> -->
      <!-- <v-btn class="ml-2" depressed rounded outlined small light color="#555">
        <v-icon size="19">mdi-wallet-plus-outline</v-icon>
        <span class="text-capitalize">Depósito</span>
      </v-btn> -->
      <!-- <v-btn class="ml-2" depressed rounded outlined small light color="#555">
        <v-icon size="19">mdi-wallet-plus-outline</v-icon>
        <span class="text-capitalize">Receber</span>
      </v-btn> -->
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getPurchases", "getLoggedUser", "getInvestments"]),
    totalPurchase() {
      let investments = this.getPurchases.filter(
        i => i.purchase_type == "investment" && (i.current_status == "active" || i.current_status == "Aguardando Pagamento")
      );
      let total = 0;
      investments.forEach(element => {
        total += parseInt(element.item.price);
      });
      return total;
    },
    proximosPagamentos() {
      const pagamentos = [];
      const hoje = this.$moment()
      let investments = this.getPurchases.filter(
        i => i.purchase_type == "investment" && i.current_status == "active"
      );
      // const active = investments.filter(s => s.current_status == 'active');
      // if (!active.length) return false;

      investments.forEach(s => {
        const data_ativacao = this.$moment(s.status.filter(s => s.status == 'ativo')[0].date);
        let proximo_pagamento;
        
        if (s.receive_type === 'mensal') {
          proximo_pagamento = this.$moment(data_ativacao).add(1, 'months');
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(1, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(2, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(3, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(4, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(5, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(6, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(7, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(8, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(9, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(10, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(11, 'months'); 
          }
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            proximo_pagamento = this.$moment(data_ativacao).add(12, 'months'); 
          }
           const tempo_ate_la = proximo_pagamento.diff(hoje, 'days');
          pagamentos.push({ ...s, tempo_ate_la });
        } else if (s.receive_type === 'trimestral') {
          proximo_pagamento = this.$moment(data_ativacao).add(3, 'months');
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            const tempo_ate_la = '"ENCERRADO"'
            pagamentos.push({ ...s, tempo_ate_la });
          } else {
            const tempo_ate_la = proximo_pagamento.diff(hoje, 'days');
            pagamentos.push({ ...s, tempo_ate_la });
          }
        } else if (s.receive_type === 'semestral') {
          proximo_pagamento = this.$moment(data_ativacao).add(6, 'months');
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            const tempo_ate_la = '"ENCERRADO"'
            pagamentos.push({ ...s, tempo_ate_la });
          } else {
            const tempo_ate_la = proximo_pagamento.diff(hoje, 'days');
            pagamentos.push({ ...s, tempo_ate_la });
          }
        } else if (s.receive_type === 'anual') {
          proximo_pagamento = this.$moment(data_ativacao).add(12, 'months');
          if (proximo_pagamento.diff(hoje, 'days') <= 0) {
            const tempo_ate_la = '"ENCERRADO"'
            pagamentos.push({ ...s, tempo_ate_la });
          } else {
            const tempo_ate_la = proximo_pagamento.diff(hoje, 'days');
            pagamentos.push({ ...s, tempo_ate_la });
          }
        }

       
      })

      return pagamentos;
    }
  },
  methods: {
    ...mapActions(['openPurchase'])
  }
};
</script>
